// @ds/actions/useRealtimeChannels — the context object + consumer hook.
//
// Split out of `RealtimeChannelsContext.tsx` so that module exports the
// provider component only.
import { createContext, useContext } from "react";

export interface RealtimeChannelsValue {
  register: (table: string, refetch: () => void) => void;
  unregister: (table: string, refetch: () => void) => void;
}

export const RealtimeChannelsContext = createContext<RealtimeChannelsValue | null>(null);

export const useRealtimeChannels = () => useContext(RealtimeChannelsContext);
